module.exports = __webpack_public_path__ + "static/media/square1.5d370eaf.png";